<template>
  <div class="contract-table">
    <vxe-toolbar size="mini">
      <template
        v-slot:buttons
        v-if="
          contractStatus == '' ||
          contractStatus == 'ZT06' ||
          contractStatus == 'ZT05' ||
          contractStatus == 'ZT061' ||
          contractStatus == 'ZT051' ||
          copyState
        "
      >
        <el-button type="primary" size="small" class="vxe-btn-primary" @click="addNewRowHandler"
          >新增</el-button
        >
        <el-button
          size="small"
          type="danger"
          class="vxe-btn-delete"
          @click="deleteBtnClickHandler()"
          >删除</el-button
        >
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-grid
      border
      size="mini"
      align="center"
      show-overflow
      show-header-overflow
      ref="xTableRef"
      class="vxe-table-element"
      resizable
      show-footer
      :auto-resize="true"
      :data="tableData"
      height="300"
      :edit-rules="tableRule"
      :edit-config="
        contractStatus == '' ||
        contractStatus == 'ZT06' ||
        contractStatus == 'ZT05' ||
        contractStatus == 'ZT061' ||
        contractStatus == 'ZT051' ||
        copyState
          ? { trigger: 'click', mode: 'row' }
          : {}
      "
      @edit-closed="closeEditTableHandler"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :footer-method="footerMethod"
    >
      <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
      <vxe-table-column type="seq" title="序号" width="80"></vxe-table-column>
      <vxe-table-column type="seq" title="行项目号" width="100"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in tableColumns"
        :key="index"
        :type="item.type"
        :fixed="item.fixed"
        :field="item.field"
        :title="item.title"
        :width="item.width"
        :visible="item.visible"
        :sortable="item.sortable"
        :edit-render="item.editRender"
      >
        <template v-slot="{ row }">
          <template v-if="item.field == 'businessChangeUnitPrice'">
            <span>{{ row[item.field] }}</span>
            <i
              v-if="contractStatus == 'ZT03' && row['isFixedPrice'] == '0'"
              class="el-icon-edit-outline icon-btn"
              @click.stop="(val) => clickBusinessOpenDialog(val, row, item.field)"
            ></i>
          </template>
          <template v-else-if="item.field == 'contractMatterName'">
            <span>{{ row[item.field] }}</span>
            <i
              v-if="contractStatus == 'ZT03' && row['isFixedPrice'] == '0'"
              class="el-icon-chat-square icon-btn"
              @click.stop="(val) => clickProductDescOpenDialog(val, row, item.field)"
            ></i>
          </template>
          <template v-else-if="item.field == 'priceConfirmDate'">
            <span>{{ row[item.field] | dateFormat }}</span>
          </template>
          <template v-else-if="item.field == 'isFixedPrice'">
            <span>{{ row[item.field] == '0' ? '否' : '是' }}</span>
          </template>
          <template v-else-if="item.field == 'unit'">
            <span>{{ row['unitName'] }}</span>
          </template>
          <template v-else-if="item.field == 'materialType'">
            <span>{{ materialTypeStr(row[item.field]) }}</span>
          </template>
          <span v-else-if="item.field == 'priceIdentity'">
            <template v-if="row[item.field] == '0'">未定价</template>
            <template v-if="row[item.field] == '1'">已定价</template>
          </span>
          <span v-else>{{ row[item.field] }}</span>
        </template>
        <template v-slot:edit="{ row }">
          <!-- 商品描述 -->
          <search-table
            v-if="item.editRender?.name == 'contractMatterName'"
            v-model="row[item.field]"
            searchType="usableProduct"
            :isMultiple="true"
            :extraData="{
              parentProductStatus: 'ZT03',
              contractCategory: $route.query.contractCategory == 'sales' ? 'sales' : 'purchase',
              adminFlag: 2,
              selectCompanyCode: companyCode,
              businessCompanyCodeList: companyList,
            }"
            :currentValue="row[item.field]"
            :disabled="
              contractStatus != '' &&
              contractStatus != 'ZT06' &&
              contractStatus != 'ZT05' &&
              contractStatus != 'ZT061' &&
              contractStatus != 'ZT051'
            "
            @input="(val) => chooseTable(val, row, item.field)"
          ></search-table>
          <!-- wumaoFix -->
          <!-- 规格 -->
          <template v-if="item.editRender?.name == 'norms'">
            <el-input disabled v-model="row[item.field]" />
            <!-- <search-table
              v-model="row[item.field]"
              searchType="goodsAllCategory"
              :isMultiple="true"
              :currentValue="row[item.field]"
              :extraData="{
                productParentCode: row.contractMatter,
              }"
              :disabled="!row.contractMatter"
              @input="(val) => chooseTable(val, row, item.field)"
            >
            </search-table> -->
          </template>
          <!-- 材料 -->
          <template v-if="item.editRender?.name == 'stuff'">
            <el-input disabled v-model="row[item.field]" />
            <!-- <el-input
              v-model="row[item.field]"
              :disabled="
                contractStatus != '' &&
                contractStatus != 'ZT06' &&
                contractStatus != 'ZT05' &&
                contractStatus != 'ZT061' &&
                contractStatus != 'ZT051'
              "
            /> -->
          </template>
          <!-- 料型 -->
          <el-select
            v-if="item.editRender?.name == 'materialType'"
            v-model="row[item.field]"
            :disabled="
              contractStatus != '' &&
              contractStatus != 'ZT06' &&
              contractStatus != 'ZT05' &&
              contractStatus != 'ZT061'
            "
          >
            <el-option
              v-for="(item, index) of materialTypeList"
              :value="item.value"
              :label="item.label"
              :key="index"
            >
            </el-option>
          </el-select>
          <!-- 销售数量 -->
          <input-number-ad
            v-if="item.editRender?.name == 'productQuantity'"
            :clearable="true"
            class="inputWidth"
            :controls="false"
            maxlength="99999999999999"
            v-model="row[item.field]"
            :precision="Number(8)"
            max="99999999999"
            @input="() => handleChange(row, item.field)"
            :disabled="
              contractStatus != '' &&
              contractStatus != 'ZT06' &&
              contractStatus != 'ZT05' &&
              contractStatus != 'ZT051' &&
              contractStatus != 'ZT021' &&
              contractStatus != 'ZT061'
            "
          >
          </input-number-ad>
          <!-- 合同含税单价 -->
          <input-number-ad
            v-if="item.editRender?.name == 'businessContractUnitPrice'"
            v-model="row[item.field]"
            disabled
            :precision="Number(6)"
            max="99999999999"
            :controls="false"
          />
          <!-- 价税合计金额 -->
          <input-number-ad
            v-if="item.editRender?.name == 'businessContractTotalAmount'"
            v-model="row[item.field]"
            :precision="Number(6)"
            max="99999999999"
            :controls="false"
            @input="() => handleChange(row, item.field)"
            :disabled="
              contractStatus != '' &&
              contractStatus != 'ZT06' &&
              contractStatus != 'ZT05' &&
              contractStatus != 'ZT051' &&
              contractStatus != 'ZT021' &&
              contractStatus != 'ZT061'
            "
          />
          <!-- 税额 -->
          <input-number-ad
            v-if="item.editRender?.name == 'businessContractTaxAmount'"
            disabled
            v-model="row[item.field]"
            :precision="Number(6)"
          />
          <!-- 净值 -->
          <input-number-ad
            v-if="item.editRender?.name == 'businessContractPureAmount'"
            disabled
            v-model="row[item.field]"
            :precision="Number(6)"
          />
          <!-- 是否定价 -->
          <el-select
            v-if="item.editRender?.name == 'isFixedPrice'"
            filterable
            clearable
            v-model="row[item.field]"
            :disabled="
              contractStatus != '' &&
              contractStatus != 'ZT06' &&
              contractStatus != 'ZT05' &&
              contractStatus != 'ZT051' &&
              contractStatus != 'ZT021' &&
              contractStatus != 'ZT061' &&
              contractStatus != 'ZT061'
            "
            @change="() => handleChange(row, item.field)"
          >
            <el-option :value="1" label="是"></el-option>
            <el-option :value="0" label="否"></el-option>
          </el-select>
          <!-- 变动后合同含税单价 -->
          <template v-if="item.editRender?.name == 'businessChangeUnitPrice'">
            <el-input disabled v-model="row[item.field]" />
          </template>
          <!-- 价格确定时间 -->
          <el-date-picker
            v-if="item.editRender?.name == 'priceConfirmDate'"
            format="yyyy-MM-dd"
            disabled
            v-model="row[item.field]"
            style="width: 100%"
          ></el-date-picker>

          <!-- 价格标识 -->
          <span v-if="item.editRender?.name == 'priceIdentity'">
            <template v-if="row[item.field] == '0'">未定价</template>
            <template v-if="row[item.field] == '1'">已定价</template>
          </span>
          <!-- 增值税 -->
          <input-number-ad
            v-if="item.editRender?.name == 'taxRate'"
            v-model="row[item.field]"
            @input="() => handleChange(row, item.field)"
            :precision="Number(6)"
            max="99999999999"
            :disabled="
              contractStatus != '' &&
              contractStatus != 'ZT06' &&
              contractStatus != 'ZT05' &&
              contractStatus != 'ZT051' &&
              contractStatus != 'ZT021' &&
              contractStatus != 'ZT061'
            "
          />
          <!-- 单位 -->
          <el-input
            v-if="item.editRender?.name == 'unit'"
            v-model="row.unitName"
            disabled
            @input="() => handleChange(row, item.field)"
          >
          </el-input>
          <!-- 起运地 -->
          <el-input
            v-if="item.editRender?.name == 'shipmentPlace'"
            v-model="row[item.field]"
            :disabled="
              contractStatus != '' &&
              contractStatus != 'ZT06' &&
              contractStatus != 'ZT05' &&
              contractStatus != 'ZT051' &&
              contractStatus != 'ZT021' &&
              contractStatus != 'ZT061'
            "
          >
          </el-input>

          <!-- 目的地 -->
          <el-input
            v-if="item.editRender?.name == 'destination'"
            v-model="row[item.field]"
            :disabled="
              contractStatus != '' &&
              contractStatus != 'ZT06' &&
              contractStatus != 'ZT05' &&
              contractStatus != 'ZT051' &&
              contractStatus != 'ZT021' &&
              contractStatus != 'ZT061'
            "
          >
          </el-input>
        </template>
      </vxe-table-column>
    </vxe-grid>
    <BusinessDialog ref="businessDialogRef" @updateProduct="updateProduct" />
    <ProductDescDialog ref="productDescDialogRef" />
  </div>
</template>

<script>
  import { baseColumnList, baseTableRule } from './index.js';
  import BusinessDialog from './BusinessDialog.vue';
  import ProductDescDialog from './ProductDescDialog.vue';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  import { formatDate } from '@/utils';
  import contractComputedMixin from './../../contractComputedMixin.js';
  import API from '@/api/dataBase.js';
  export default {
    name: 'ShopDetailContractTable',
    mixins: [contractComputedMixin],
    data() {
      return {
        selectionList: [],
        tableData: [],
        materialTypeList: [],
        status: '',
        currentRowId: null,
        companyCode: '',
        isShowVariablePriceIcon: false, // 是否显示修改定价
        isRestrict: null,
        companyList: [],
      };
    },
    props: {
      orderDetailList: {
        type: Array,
        default: () => [],
      },
      contractStatus: {
        type: String,
        default: () => '',
      },
      baseFormData: {
        type: Object,
      },
      detailPageData: {
        type: Object,
        default: () => {},
      },
      parentIsRestrict: {
        type: String,
        default: '0',
      },
    },
    computed: {
      tableColumns() {
        return baseColumnList(this);
      },
      tableRule() {
        return baseTableRule(this);
      },
      copyState() {
        console.log('copyState', this.$route.query.isCopy);
        return this.$route.query.isCopy;
      },
    },
    methods: {
      // 获取当前登陆人下面的所有公司数据
      async getCompany() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        this.$axios.post(API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            // 获取公司下拉
            let companyList = res.data.data.personCompanyInfo || [];
            this.companyList = companyList.map((item) => {
              return item?.personCompanyCode;
            });
          }
        });
      },
      // 单独处理料型
      materialTypeStr(item) {
        return this.materialTypeList.find((it) => it.value == item)?.label;
      },
      async priceChangeHandler({ price, count }) {
        console.log('changePrice', price, count);

        let row = this.tableData.find((item) => item._XID == this.currentRowId);

        let contractDetailNo = this.tableData.indexOf(row);

        console.log('rowData', row);

        let params = {
          contractNo: this.$route.query.contractNo,
          contractDetailNo: row.contractDetailNo || contractDetailNo,
          pricingRule: this.pricingRule,
          tenantCode: this.userInfo.tenantCode,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          productNo: row.productNo,
          productDesc: row.productDesc,
          productUnit: row.unit,
          productUnitName: row.unitName,
          salesUnitPrice: row.businessContractUnitPrice,
          operatorNo: this.userInfo.userCode,
          operatorName: this.userInfo.userName,
          version: row.version,
          id: row.id,
          temporaryPrice: price,
          productQuantity: count,
        };

        //确认变更单价
        this.$axios.post('/sales/orderSaleDetailPricing/savePricing', params).then((res) => {
          if (0 != res.data.code) {
            this.tableData.map((item) => {
              if (item._XID == this.currentRowId) {
                return {
                  ...item,
                  businessChangeUnitPrice: price,
                };
              }
              return item;
            });
            this.$alert(res.data.msg);
          }
        });
      },
      // 刷新表格数据
      updateProduct(obj) {
        if (obj.prop == 'priceChange') {
          let row = obj.val;
          const productList = this.$refs.xTableRef.getTableData().fullData;
          productList.map((item) => {
            if (item.id == row.id) {
              item.businessChangeUnitPrice = row.businessChangeUnitPrice;
              item.priceConfirmDate = row.priceConfirmDate;
              item.priceIdentity = row.priceIdentity;
              item.businessChangeTaxAmount = row.businessContractTaxAmount;
              item.version = row.version;
              item.isPricingRecord = row.isPricingRecord;
              item.avgUnitPrice = row.avgUnitPrice;
              item.businessChangeUnitPrice = row.temporaryPrice;
            }
          });
          // 更新表格数据
          this.$refs.xTableRef.reloadData(productList);
        }
      },
      // 正常编辑的选中
      handleChange(row, field) {
        console.log(row, field, '行');
        if (
          // field === 'businessContractUnitPrice' ||
          field === 'businessContractTotalAmount' ||
          field === 'productQuantity' ||
          field == 'taxRate'
        ) {
          if (field === 'taxRate') {
            if (row['taxRate'] > 1 || row['taxRate'] < 0) {
              this.$message.error('增值税只能是0-1之间的数值');
              row['taxRate'] = 0;
            }
          }
          let quantity = row['productQuantity'] || 0;
          let price = row['businessContractUnitPrice'] || 0;
          console.log('listPrice', quantity, price);
          // row['businessContractTotalAmount'] = this.computedBusinessContractTotalAmount(row); // 价税合计金额
          row['businessContractUnitPrice'] = this.computedBusinessContractUnitPrice(row);
          row['businessContractTaxAmount'] = this.computedBusinessContractTaxAmount(row); // 税额
          row['businessContractPureAmount'] = this.computedBusinessContractPureAmount(row); // 净值
          row['businessChangeTaxAmount'] = row['businessContractTaxAmount'];

          if (field === 'businessContractUnitPrice') {
            if (price) {
              row['businessChangeUnitPrice'] = Number(price);
            }
          }
        } else if (field === 'isFixedPrice') {
          if (row['isFixedPrice'] == 1) {
            row['priceIdentity'] = '1';
          } else {
            row['priceIdentity'] = '0';
          }
        } else if (field === 'contractMatterName') {
          console.log('商品描述', row['contractMatter']);
        }
      },
      chooseTable(val, row, field) {
        console.log(val, row, field, '监听');
        console.log(JSON.stringify(val));
        if (field == 'contractMatterName') {
          const rowData = val[0];
          console.log('rowData', rowData);
          row['contractMatterName'] = rowData?.productChName;
          if (rowData?.productDetailCode && rowData?.productDetailCode.length != 0) {
            row['contractMatter'] = rowData?.productDetailCode;
          } else {
            row['contractMatter'] = rowData?.parentProductNo;
          }
          if (rowData?.detailProductModel && rowData?.detailProductModel.length != 0) {
            row['norms'] = rowData?.detailProductModel;
          }
          row['stuff'] = rowData?.detailProductMaterial ?? '';
          row['detailProductVendor'] = rowData?.detailProductVendor ?? '';
          let product = rowData;

          //如果没有选产品 则不走下面的逻辑
          if (product) {
            row.productNo = product.parentProductNo;
            row.productDesc = product.productChName;
            row.taxCode = product.salesTaxCode || 0;
            row.taxName = row.taxCode
              ? this.addedTaxRateOptions?.find((options) => {
                  return row.taxCode == options.taxCode;
                }).taxName
              : '';
            row.taxRate = product.salesTaxRate || 0;
            // 进口普通关税率
            row.importNormalTariffRate = product.importNormalTariffRate || 0;
            row.unit = product.basicUnit || null;
            row.unitName = product.basicUnitName || null;
            row['businessContractTotalAmount'] = this.computedBusinessContractTotalAmount(row); // 价税合计金额
            row['businessContractTaxAmount'] = this.computedBusinessContractTaxAmount(row); // 税额
            row['businessContractPureAmount'] = this.computedBusinessContractPureAmount(row); // 净值
            row['businessChangeTaxAmount'] = row['businessContractTaxAmount'];
            console.log(product.businessContractTaxAmount, '税额');
          }
        } else if (field == 'norms') {
          // row['norms']=
        }
      },
      // 新增行
      async addNewRowHandler() {
        if (!['0', '1'].includes(this.isRestrict)) {
          this.$message.error('请先选择是否定量');
          return;
        }
        const rowData = {
          priceConfirmDate: new Date(),
          businessChangeUnitPrice: 0,
          productQuantity: this.isRestrict == '0' ? '0' : '',
        };
        const $table = this.$refs.xTableRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, 0);
          await $table.setActiveRow(newRow); // 设置当前行为活跃
          await $table.validate(newRow).catch((errMap) => errMap);
          this.$emit('isDisabledIsRestrict', true);
        }
      },

      // 删除
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const $table = this.$refs.xTableRef;
        const tableData = $table.getTableData().fullData;
        this.tableData = tableData.filter((item) => !XIDList.includes(item._XID));

        // 判断当前删除中是否有id
        const idList = this.selectionList.map((item) => item.id); // 全部被删除的id

        // 删除的id数据传给父
        this.$emit('tableDeleteNotifier', idList);
        this.$emit('closeTableHandler', this.tableData);
        if (this.tableData.length == 0) {
          this.$emit('isDisabledIsRestrict', false);
        }
      },
      // 选择行
      handleSelectionChange(row) {
        console.log(row, '选择行');
        this.selectionList = row.selection;
      },
      // 获取表格数据
      getTableData() {
        return new Promise((resolve, reject) => {
          const $table = this.$refs.xTableRef;
          const tableData = $table.getTableData().fullData;
          $table.validate((valid) => {
            if (valid && tableData.length) {
              if (this.isRestrict == '1' && tableData.some((item) => item.productQuantity == 0)) {
                this.$message.error('当前属于限购，销售数量不能为0');
                reject({ tableData: [] });
              } else {
                const tableData1 = tableData.map((item, index) => {
                  return {
                    ...item,
                    contractDetailNo: index + 1,
                    priceConfirmDate: item.priceConfirmDate
                      ? formatDate(item.priceConfirmDate)
                      : null,
                    productQuantity: item.productQuantity || 0,
                    businessContractUnitPrice: item.businessContractUnitPrice || 0,
                    businessContractTotalAmount: item.businessContractTotalAmount || 0,
                  };
                });
                resolve({ tableData: tableData1 });
              }
            } else {
              this.$message.error('请填写表格数据');
              reject({ tableData: [] });
            }
          });
        });
      },
      // 关闭的时候数据校验
      async closeEditTableHandler() {
        const $table = this.$refs.xTableRef;
        const tableData = $table.getTableData().fullData;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          this.$message.error('请检查数据再提交');
        } else {
          await $table.clearActived();
          console.log(tableData, '1111111');
          // 派发事件更新表单数据
          this.$emit('closeTableHandler', tableData);
        }
      },
      // 点击打开编辑价格弹框
      clickBusinessOpenDialog(val, row, fieldName) {
        console.log(val, row, fieldName);
        this.$refs.businessDialogRef.openModal(
          row,
          this.detailPageData.pricingRule
          // this.detailPageData.overShippedPercentage
        );
      },
      // 详情弹框
      clickProductDescOpenDialog(val, row, fieldName) {
        console.log(val, row, fieldName);
        this.$refs.productDescDialogRef.openModal(row);
      },
      // 表底合并
      footerMethod({ columns, data }) {
        const footerData = [
          columns.map((column, _columnIndex) => {
            if (_columnIndex === 0) {
              return '小计';
            }
            if (column.property === 'productQuantity') {
              return data.reduce((cur, next) => cur + +next.productQuantity, 0).toFixed(8);
            }
            return '-';
          }),
        ];
        return footerData;
      },
      // 反填数据到表格中
      fullTableData(val) {
        if (val && Array.isArray(val) && val.length) {
          this.tableData = val;
        }
      },
    },
    mounted() {
      // 料型下拉框
      this.materialTypeList = this.dictListMap.materialType;
      this.getCompany();
    },
    watch: {
      orderDetailList: {
        handler(val) {
          this.fullTableData(val);
        },
        immediate: true,
        deep: true,
      },
      baseFormData: {
        handler(val) {
          this.companyCode = val.companyCode ?? this.userInfo.companyCode;
        },
        immediate: true,
        deep: true,
      },
      parentIsRestrict: {
        handler(val) {
          console.log(val, '监听');
          this.isRestrict = val;
          // this.tableData = [];
        },
        immediate: true,
      },
    },
    components: {
      BusinessDialog,
      ProductDescDialog,
      inputNumberAd,
    },
  };
</script>

<style lang="scss" scoped>
  .contract-table {
    ::v-deep {
      .vxe-body--column .vxe-cell {
        position: relative;
      }
    }

    .icon-btn {
      cursor: pointer;
      position: absolute;
      font-size: 16px;
      top: 5px;
      right: 6px;
      color: rgb(98, 153, 254);
    }
  }
</style>
